import CommonObj from "../../CommonObj";
import { encryptTimestamp } from "../commoncsrf/csrf-common";

class RegexService {
  constructor() {
    this.regexData = null;
  }

  async fetchRegexData(accessToken) {
    if (this.regexData) {
      return this.regexData;
    }

    try {
      const response = await fetch(CommonObj.Endpoints.GetRegexValidation, {
          method: "GET",
          mode: "cors",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-CSRF-Token": encryptTimestamp(),
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      this.regexData = await response.json();
      return this.regexData;
    } catch (error) {
      console.error("Failed to fetch regex data:", error);
      throw error;
    }
  }

    formatStandardRack(value) {
        if (!value) return "";

        if (!this.regexData || this.regexData.length === 0) {
            return value.trim().toUpperCase();
        }

        for (const pattern of this.regexData) {
            if (pattern.replaceRack) {
                try {
                    const replaceRegex = new RegExp(pattern.replaceRack, 'gi');
                    // Test if the string contains the replace pattern (e.g., "Rack - ")
                    if (replaceRegex.test(value)) {
                        // Strip out the prefix, trim whitespace, and construct the standard format
                        const rackNo = value.replace(replaceRegex, "").trim();
                        return rackNo;
                    }
                } catch (e) {
                    console.error(`Invalid replaceRack pattern for regexId ${pattern.regexId}:`, e);
                    continue;
                }
            }
        }

        return value.trim().toUpperCase();
    }

  // Validates against ALL rack patterns
  validateRack(value) {
    if (!this.regexData || this.regexData.length === 0) {
      throw new Error("Regex data not loaded. Call fetchRegexData() first.");
    }

    // Iterate through all regex patterns
    for (const pattern of this.regexData) {
      try {
        const regex = new RegExp(pattern.rack, 'i');
        if (regex.test(value)) {
          return { isValid: true, error: "" };
        }
      } catch (e) {
        console.error(`Invalid regex pattern for regexId ${pattern.regexId}:`, e);
        continue;
      }
    }

    return {
      isValid: false,
      error: "Invalid Rack format. The value doesn't match any of the configured patterns"
    };
  }

  // Validates against ALL rackShelf patterns
  validateRackShelf(value) {
    if (!this.regexData || this.regexData.length === 0) {
      throw new Error("Regex data not loaded. Call fetchRegexData() first.");
    }

    // Iterate through all regex patterns
    for (const pattern of this.regexData) {
      try {
        const regex = new RegExp(pattern.rackShelf, 'i');
        if (regex.test(value)) {
          return { isValid: true, error: "" };
        }
      } catch (e) {
        console.error(`Invalid regex pattern for regexId ${pattern.regexId}:`, e);
        continue;
      }
    }

    return {
      isValid: false,
      error: "Invalid Rack Shelf format. The value doesn't match any of the configured patterns"
    };
  }

  clearCache() {
    this.regexData = null;
  }
}

export default new RegexService();

export const removeSpaces = (str) => str?.replace(/[-\s]/g, '');
